<template>
  <!-- Accessibility attributes, see: https://stackoverflow.com/a/59566339/2464295 -->
  <div
    class="flex flex-col justify-center items-center"
    role="progressbar"
    aria-live="polite"
    aria-busy="true"
  >
    <div
      :class="[
        'animate-spin',
        'rounded-full',
        `h-${spinnerSize}`,
        `w-${spinnerSize}`,
        'border-b-2',
        'border-primary',
      ]"
    ></div>
    <div v-if="message" class="mt-8">{{ message }}</div>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    message?: string | null
    spinnerSize?: string
  }>(),
  {
    spinnerSize: '12',
    message: null,
  }
)
</script>

<style lang="scss" scoped></style>
